import styled, { css } from 'styled-components'

import { ButtonPlain } from '../ButtonPlain'

type Props = {
	isVisible: boolean
}

export const buttonLoadingStyles = css<Props>`
	display: inline-block;
	position: relative;
	vertical-align: middle;
	touch-action: manipulation;
	white-space: nowrap;
	cursor: pointer;
	user-select: none;
	overflow: hidden;
	height: 36px;
	min-width: 72px;
	max-width: 100%;
	padding: 5px 30px;
	flex-grow: 0;

	color: #FFF;
	background-color: #000;
	border: none;

	text-align: center;
	font-size: 1rem;

	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

	margin: 2px;

	&:first-child {
		margin-left: 0;
	}

	&:last-child {
		margin-right: 0;
	}

	&:is(:focus, :focus-visible, :hover, :active) {
		outline: 0;
		text-decoration: none;
	}

	&:disabled {
		cursor: default;
		box-shadow: none;
	}
`

export const Button = styled(ButtonPlain)<Props>`
	position: relative;
	vertical-align: middle;
	white-space: nowrap;
	user-select: none;
	overflow: hidden;
	height: 36px;
	min-width: 72px;
	max-width: 100%;
	padding: 5px 30px;
	flex-grow: 0;

	color: #FFF;
	background-color: #000;
	border: none;

	text-align: center;
	font-size: 1rem;

	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

	margin: 2px;

	&:first-child {
		margin-left: 0;
	}

	&:last-child {
		margin-right: 0;
	}
`
